import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React from 'react';

import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';

type LoginFormLayoutProps = {
  children: React.ReactNode;
};

const LoginFormLayout: React.FC<LoginFormLayoutProps> = ({ children }) => {
  const classes = useStyles();
  const logoPath = '/image/logo.webp';

  return (
    <Grid container className={classes.container} justifyContent="center" alignItems="center">
      <ShadowBoxComponent className={classes.box}>
        <Grid container justifyContent="center" direction="column" spacing={1}>
          <img src={logoPath} alt="" className={classes.logo} />
          {children}
        </Grid>
      </ShadowBoxComponent>
    </Grid>
  );
};

const useStyles = makeStyles({
  container: {
    height: '100%',
  },
  box: {
    maxWidth: 550,
    width: '100%',
    padding: 25,
  },
  logo: {
    width: 250,
    margin: 'auto',
    marginBottom: 30,
  },
});

export default LoginFormLayout;
